import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core'

@Component({
  selector: 'accordion',
  templateUrl: './accordion.component.html',
  styleUrls: ['./accordion.component.css'],
})
export class AccordionComponent implements OnInit {
  public visible: boolean = true

  @Input() public title: string
  @Output() public onChange: EventEmitter<any> = new EventEmitter()

  constructor() {}

  ngOnInit() {}
}
